module.exports = __webpack_public_path__ + "img/icon_continuous_color.56705cf2.svg";